<template>
    <div class="login-container">
        <div v-if="!isLoggedIn" class="login-card">
            <div class="login-header">
                <div class="login-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                        <polyline points="10,17 15,12 10,7"/>
                        <line x1="15" y1="12" x2="3" y2="12"/>
                    </svg>
                </div>
                <h2>Bejelentkezés</h2>
                <p>Üdvözöljük a RSPCT-Core alkalmazásban</p>
            </div>
            
            <form @submit.prevent="login" class="login-form">
                <div class="form-group">
                    <label for="email" class="form-label">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                            <polyline points="22,6 12,13 2,6"/>
                        </svg>
                        Email cím
                    </label>
                    <input 
                        type="email" 
                        id="email"
                        class="form-control" 
                        v-model="email" 
                        placeholder="pelda@email.com" 
                        required 
                    />
                </div>
                
                <div class="form-group">
                    <label for="password" class="form-label">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                            <circle cx="12" cy="16" r="1"/>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                        </svg>
                        Jelszó
                    </label>
                    <input 
                        type="password" 
                        id="password"
                        class="form-control" 
                        v-model="password" 
                        placeholder="••••••••" 
                        required 
                    />
                </div>
                
                <button type="submit" class="btn btn-primary login-btn">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                        <polyline points="10,17 15,12 10,7"/>
                        <line x1="15" y1="12" x2="3" y2="12"/>
                    </svg>
                    Bejelentkezés
                </button>
                
                <div v-if="error" class="alert alert-error">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="15" y1="9" x2="9" y2="15"/>
                        <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                    {{ error }}
                </div>
                
                <div v-if="email_msg" class="alert alert-success">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                        <polyline points="22,4 12,14.01 9,11.01"/>
                    </svg>
                    {{ email_msg }}
                </div>

                <!-- Forgot password link -->
                <div class="forgot-password">
                    <button type="button" @click="requestPasswordReset" class="forgot-link">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="3"/>
                            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                        </svg>
                        Elfelejtett jelszó?
                    </button>
                </div>
                        <div class="d-flex justify-content-center mt-5">
                            <a href="./adatvedelmi_datapod.pdf" download="adatvédelmi_nyilatkozat_datapod.pdf">Adatvédelmi nyilatkozat</a>
                        </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            email: '',
            password: '',
            error: null,
            email_msg: ''
        };
    },
    methods: {
        // Login function
        login() {
            return this.$login();
        },

        // Handle Forgot Password request
        async requestPasswordReset() {
            const email = this.email;
            if (!email) {
                this.error = 'Kérem adja meg az email címét!';
                return;
            }

            try {
                const response = await axios.post(this.$BACKEND_HOST + '/api/email/reset', { email });
                this.email_msg = "Az email elküldve."
            } catch (err) {
                this.error = 'Hiba történt a jelszó-visszaállítás kérésében.';
            }
        },
    },
};
</script>

<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 2rem 1rem;
}

.login-card {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-xl);
    padding: 2.5rem;
    width: 100%;
    max-width: 420px;
    border: 1px solid var(--color-border);
    position: relative;
    overflow: hidden;
}

.login-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--primary-blue), var(--secondary-blue), var(--accent-blue));
}

.login-header {
    text-align: center;
    margin-bottom: 2rem;
}

.login-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
    border-radius: 50%;
    margin-bottom: 1rem;
    color: white;
    box-shadow: var(--shadow-lg);
}

.login-header h2 {
    color: var(--color-heading);
    font-size: 1.75rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.login-header p {
    color: var(--color-text-muted);
    font-size: 0.95rem;
    margin: 0;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
    color: var(--color-heading);
    font-size: 0.875rem;
}

.form-label svg {
    color: var(--primary-blue);
    flex-shrink: 0;
}

.form-control {
    width: 100%;
    padding: 0.875rem 1rem;
    border: 2px solid var(--color-border);
    border-radius: 10px;
    background: var(--white);
    color: var(--color-text);
    font-size: 1rem;
    transition: all 0.3s ease;
    font-family: inherit;
}

.form-control:focus {
    outline: none;
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    transform: translateY(-1px);
}

.form-control::placeholder {
    color: var(--color-text-muted);
}

.login-btn {
    width: 100%;
    padding: 1rem 1.5rem;
    background: linear-gradient(135deg, var(--primary-blue), var(--primary-blue-light));
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.login-btn:hover {
    background: linear-gradient(135deg, var(--primary-blue-dark), var(--primary-blue));
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
}

.login-btn:active {
    transform: translateY(0);
}

.alert {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
    border-radius: 10px;
    font-size: 0.875rem;
    font-weight: 500;
    margin-top: 0.5rem;
}

.alert-error {
    background: rgba(239, 68, 68, 0.1);
    color: var(--error);
    border: 1px solid rgba(239, 68, 68, 0.2);
}

.alert-success {
    background: rgba(16, 185, 129, 0.1);
    color: var(--success);
    border: 1px solid rgba(16, 185, 129, 0.2);
}

.alert svg {
    flex-shrink: 0;
}

.forgot-password {
    text-align: center;
    margin-top: 1rem;
}

.forgot-link {
    background: none;
    border: none;
    color: var(--primary-blue);
    font-size: 0.875rem;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-weight: 500;
}

.forgot-link:hover {
    background: rgba(37, 99, 235, 0.1);
    color: var(--primary-blue-dark);
}

.forgot-link svg {
    flex-shrink: 0;
}

/* Responsive design */
@media (max-width: 768px) {
    .login-container {
        padding: 1rem 0.75rem;
        min-height: 50vh;
    }
    
    .login-card {
        padding: 2rem 1.5rem;
        max-width: 100%;
    }
    
    .login-icon {
        width: 64px;
        height: 64px;
    }
    
    .login-header h2 {
        font-size: 1.5rem;
    }
    
    .form-control {
        padding: 0.75rem 1rem;
    }
    
    .login-btn {
        padding: 0.875rem 1.25rem;
    }
}

@media (max-width: 480px) {
    .login-container {
        padding: 0.75rem 0.5rem;
    }
    
    .login-card {
        padding: 1.5rem 1rem;
        border-radius: 12px;
    }
    
    .login-icon {
        width: 56px;
        height: 56px;
    }
    
    .login-header h2 {
        font-size: 1.375rem;
    }
    
    .login-form {
        gap: 1.25rem;
    }
}
</style>
